import { render } from "./AdsToolbar.vue?vue&type=template&id=22076da7"
import script from "./AdsToolbar.vue?vue&type=script&lang=js"
export * from "./AdsToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__